import { ErrorTextProps } from '../form-helper-text/form-helper-text';

export type DatePickerSize = 'medium' | 'large';

export interface DateRangePickerProps {
  /** The year to default to */
  defaultYear?: number;
  /** The month to default to */
  defaultMonth?: number;
  /** The start date of the range */
  selectionStart?: Date;
  /** The end date of the range */
  selectionEnd?: Date;
  /** Whether to display clear icon */
  allowClear?: boolean;
  /** Called when the date changes */
  onChange: (selection: [Date?, Date?]) => void;
  /** Called when the calendar opens or closes */
  onOpenChange?: (isOpen: boolean) => void;
  /** Called when a change is made with the Calendar */
  onCalendarChange?: (selection: [Date?, Date?]) => void;
  /** Function to disable dates */
  isDisabledDate?: (date: Date) => boolean;
  /** Error text props */
  errorProps?: ErrorTextProps;
  /** Size of the input */
  containerSize?: DatePickerSize;
}

export interface DatePickerCalendarProps extends Omit<DateRangePickerProps, 'onOpenChange'> {
  /** Whether to display the range selection */
  rangeSelection?: boolean;
}

export interface DatePickerProps extends Omit<DateRangePickerProps, 'selectionEnd' | 'selectionStart' | 'onChange'> {
  /** The current selected date */
  selectedDate?: Date;
  /** Called when the date changes */
  onChange: (selection: Date | undefined) => void;
}

export interface DatePickerDayProps {
  date: Date;
  isDisabled: boolean;
  selectionStart?: Date;
  selectionEnd?: Date;
  isCurrentMonth: boolean;
  isRangeSelection: boolean;
  toggleSelection: (date: Date) => void;
}

export interface DateMenuProps {
  state: DatePickerState;
  dispatch: React.Dispatch<DatePickerAction>;
  onChange: (selection: [Date?, Date?]) => void;
  isDisabledDate?: (date: Date) => boolean;
}

export type CalendarMenuProps = Omit<DateMenuProps, 'onChange'>;

export enum DatePickerActionType {
  SELECT_DATE = 'SELECT_DATE',
  NEXT_MONTH = 'NEXT_MONTH',
  PREV_MONTH = 'PREV_MONTH',
  SET_RANGE = 'SET_RANGE',
  SET_MENU = 'SET_MENU',
  SET_MONTH = 'SET_MONTH',
  SET_YEAR = 'SET_YEAR',
  PREV_YEAR = 'PREV_YEAR',
  NEXT_YEAR = 'NEXT_YEAR',
}

export enum CalendarMenuType {
  DATE_MENU = 'DATE_MENU',
  MONTH_MENU = 'MONTH_MENU',
  YEAR_MENU = 'YEAR_MENU',
}

export type DatePickerAction =
  | {
      type: 'SELECT_DATE';
      payload: [Date?, Date?];
    }
  | { type: 'NEXT_MONTH' }
  | { type: 'PREV_MONTH' }
  | { type: 'PREV_YEAR' }
  | { type: 'NEXT_YEAR' }
  | { type: 'SET_RANGE'; start: Date | undefined; end: Date | undefined }
  | { type: 'SET_MENU'; menu: CalendarMenuType }
  | { type: 'SET_MONTH'; month: number }
  | { type: 'SET_YEAR'; year: number };

export interface DatePickerState {
  year: number;
  month: number;
  selectionStart?: Date;
  selectionEnd?: Date;
  isRangeSelection: boolean;
  menu: CalendarMenuType;
  previousMenu: CalendarMenuType;
}
